import {DeleteProfileRequest, DeleteProfileResponse, IDeleteProfileRequest} from "../../compiled";
import {useState} from "react";
import {useRpcSender} from "../../RpcSender";
import {useProfile} from "../../UserProfileProvider";
import {useNavigate} from "react-router-dom";
import {RpcState} from "../RpcState";

export const useDebugDeleteUserRpc = () => {

  const rpcSender = useRpcSender()
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'})
  const navigate = useNavigate()

  const {setProfile} = useProfile();

  const send = (request: IDeleteProfileRequest) => {
    setRpcState({state: 'pending'});
    rpcSender.send("delete_user", DeleteProfileRequest.encode(request).finish())
        .then(bytes => {
          let response = DeleteProfileResponse.decode(bytes);
          if (response.okay) {
            setProfile(response.updated);
            navigate('/');
          } else {
            setRpcState({state: 'error'});
          }
        })
        .catch(e => {
          setRpcState({state: 'error'});
        });
  }
  
  return {send, rpcState}
}